import React, { useEffect, useState } from "react";
import { Box, Grid, Card, Typography, CircularProgress } from "@mui/material";
import api from "../../utils/api"; // adjust path as needed

const cardStyle = {
  px: 3,
  py: 2,
  minHeight: 90,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  backgroundColor: "#f9f9f9",
  boxShadow: 1,
  borderRadius: 2,
};

const formatValue = (val) => {
  if (val == null || val === "") {
    return (
      <Typography variant="body2" fontStyle="italic" color="text.secondary">
        N/A
      </Typography>
    );
  }

  const numeric = parseFloat(val);
  return isNaN(numeric)
    ? val
    : numeric.toLocaleString();
};

const OverviewSummaryCards = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await api.get("/workorder-summary");
        const data = res.data;

        setStats({
          thisMonth: data.thisMonth,
          resolvedThisMonth: data.resolvedThisMonth,
          pendingThisMonth: data.pendingThisMonth,
          avgResolution: data.avgResolution != null ? `${data.avgResolution} days` : null,
        });
      } catch (err) {
        console.error("Error fetching summary:", err);
        setStats(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, []);

  const items = [
    { label: "Work Orders This Month", value: stats?.thisMonth, emoji: "📅" },
    { label: "Resolved This Month", value: stats?.resolvedThisMonth, emoji: "✅" },
    { label: "Pending This Month", value: stats?.pendingThisMonth, emoji: "⏳" },
    { label: "Avg. Resolution Time This Month", value: stats?.avgResolution, emoji: "⏱" },
  ];

  return (
    <Box sx={{ mb: 3 }}>
      {loading ? (
        <Box sx={{ textAlign: "center", py: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          {items.map((item, idx) => (
            <Grid item xs={12} sm={6} md={3} key={idx}>
              <Card sx={cardStyle}>
                <Typography variant="body2" color="text.secondary">
                  {item.emoji} {item.label}
                </Typography>
                <Typography variant="h6" fontWeight="bold">
                  {formatValue(item.value)}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default OverviewSummaryCards;
